// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"eventsList_is-mob__OLu1X","is-desk":"eventsList_is-desk__PmL7U","list":"eventsList_list__vozcT"};